/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-computed-properties-in-native-classes, ember/no-get */
import Controller, { inject as controller } from '@ember/controller';
import { tracked } from '@glimmer/tracking';
import { action, computed } from '@ember/object';
import { alias } from '@ember/object/computed';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import Jurisdiction from '@linc-technologies/linced-common/enums/jurisdiction';

export default class TriangulationController extends Controller {
  @service
  session;

  @service
  router;

  @controller('group.triangulation.combined')
  combined;

  Jurisdiction = Jurisdiction;

  @alias('session.school')
  school;

  @alias('school.jurisdiction')
  jurisdiction;

  @computed('jurisdiction')
  get jurisdictionIsUK() {
    return this.jurisdiction === Jurisdiction.UK;
  }

  @computed('router.currentRouteName')
  get isSingleSubject() {
    return [
      'group.triangulation.subject',
      'group.triangulation.subject_loading',
    ].includes(this.router.currentRouteName);
  }

  @computed('router.currentRouteName')
  get isCombined() {
    return this.router.currentRouteName === 'group.triangulation.combined';
  }

  @computed('isCombined', 'combined.currentMilestoneId')
  get isCombinedMilestone() {
    return this.isCombined && !isEmpty(this.combined.currentMilestoneId);
  }

  @tracked
  selectedMilestoneSet = null;

  @computed('model.subjects.[]', 'selectedMilestoneSet.{id,isDefault}')
  get subjects() {
    if (isEmpty(this.model) || isEmpty(this.selectedMilestoneSet)) {
      return [];
    }
    let subjects = this.model.subjects;
    if (this.get('selectedMilestoneSet.isDefault')) {
      // Hide any subjects which are using a Milestone Set.
      subjects = subjects.filter((item) => !item.milestone_set_id);
    } else {
      subjects = subjects.filter(
        (item) => item.milestone_set_id === this.get('selectedMilestoneSet.id'),
      );
    }
    return subjects
      .slice()
      .sort(
        (a, b) =>
          a.sequence - b.sequence ||
          (a.label || '').localeCompare(b.label || ''),
      );
  }

  @action
  selectMilestoneSet(milestoneSet) {
    this.selectedMilestoneSet = milestoneSet;
    // The "combined" view doesn't need redirecting to a subject.
    if (this.isCombined) {
      this.combined.set('currentMilestoneId', null);
    } else {
      if (isEmpty(this.subjects)) {
        this.router.transitionTo('group.triangulation.index', this.model.group);
      } else {
        this.router.transitionTo(
          'group.triangulation.subject',
          this.model.group.id,
          this.subjects[0].id,
        );
      }
    }
  }
}
